import { render, staticRenderFns } from "./PageApps.vue?vue&type=template&id=b29ef9c2&scoped=true&"
import script from "./PageApps.vue?vue&type=script&lang=js&"
export * from "./PageApps.vue?vue&type=script&lang=js&"
import style0 from "./PageApps.vue?vue&type=style&index=0&id=b29ef9c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29ef9c2",
  null
  
)

export default component.exports